module.exports = __webpack_public_path__ + "img/expostyle_9248_cacao_pantone2322c.49239ec5.jpg";